export function imageUrls(value) {
  if (Array.isArray(value)) return [...new Set(value.flatMap(imageUrls))];
  if (typeof value !== 'string' || !value.trim()) return [];
  const trimmed = value.trim();
  if (trimmed.startsWith('[') || trimmed.startsWith('"')) {
    try { const decoded = JSON.parse(trimmed); if (decoded !== value) return imageUrls(decoded); } catch { return []; }
  }
  return [trimmed];
}
export function normalizeTaskResult(data = {}) {
  const urls = imageUrls(data.result_urls || data.result_url || data.download_url || data.result_image_path);
  return { ...data, download_url: urls[0] || '', result_image_path: urls[0] || '', result_urls: urls.length > 1 ? urls : null };
}
